module.exports = __webpack_public_path__ + "static/media/privacypolicy.989d0932.htm";